import { ChannelConfiguration } from 'api/notifications';

export interface ThresholdConfig {
  thresholdId: number;
  thresholdValue: 50;
  notifyProjectOwners: boolean;
  notifyProjectMembers: boolean;
  notifyUsers: number[];
}

export interface UpdateFinancialAlertPayload {
  accountNotificationConfigurationMeta: {
    projectThresholdNotificationConditions: ThresholdConfig[];
  };
}

export enum FinancialNotificationEventType {
  ProjectBudgetThresholdReached = 'ProjectBudgetThresholdReached',
  ProjectHoursThresholdReached = 'ProjectHoursThresholdReached',
}

export interface FinancialNotificationConfig {
  accountId: number;
  accountNotificationConfigId: number;
  channels: ChannelConfiguration;
  createdAt: string;
  eventType: FinancialNotificationEventType;
  updatedAt: string;
  updatedBy: number;
  accountNotificationConfigurationMeta?: {
    projectThresholdNotificationConditions: ThresholdConfig[];
  };
}
